import { combineReducers } from 'redux';

import options from './options';
import sidebar from '../Sidebar/reducer';
import notifications from '../MonitorNav/Notifications/reducer';
import toasts from '../SuspiciousUserToasts/reducer';
import warnPopup from '../MonitorNav/Notifications/Notification/WarnBtn/reducer';

export default combineReducers({
  options,
  sidebar,
  notifications,
  toasts,
  warnPopup,
});
